import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Cross, Bell } from '../../utils/icons';
import { SignUpButton }  from "../HotelPanel/styles";
import { CloseBtn, Modal, ModalHeader, Button, ModalButtonContainer, ModalContainer, ModalTitle } from './styles';
import { openModal } from '../../redux/actions';

const SelectorModalMobile = ({ children, handleCloseButtonClick, total, title, handleClearButtonClick, loading, displayShowButton, handleModalOpenClick, waitlistFeature = false }) => {

  const renderButtonContent = () => {
    let content;

    if (loading) {
      content = (
        <Fragment>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="loader"
            preserveAspectRatio="xMidYMid"
            style={{ width: '115px', height: '20px' }}
            viewBox="0 0 68 14"
          >
            <g transform="translate(7 7)">
              <circle r="7" fill="#ffffff" transform="scale(0.8984)">
                <animateTransform
                  attributeName="transform"
                  begin="-0.375s"
                  calcMode="spline"
                  dur="1s"
                  keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                  keyTimes="0;0.5;1"
                  repeatCount="indefinite"
                  type="scale"
                  values="0;1;0"
                />
              </circle>
            </g>
            <g transform="translate(27 7)">
              <circle r="7" fill="#ffffff" transform="scale(0.59269)">
                <animateTransform
                  attributeName="transform"
                  begin="-0.25s"
                  calcMode="spline"
                  dur="1s"
                  keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                  keyTimes="0;0.5;1"
                  repeatCount="indefinite"
                  type="scale"
                  values="0;1;0"
                />
              </circle>
            </g>
            <g transform="translate(47 7)">
              <circle r="7" fill="#ffffff" transform="scale(0.2416)">
                <animateTransform
                  attributeName="transform"
                  begin="-0.125s"
                  calcMode="spline"
                  dur="1s"
                  keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                  keyTimes="0;0.5;1"
                  repeatCount="indefinite"
                  type="scale"
                  values="0;1;0"
                />
              </circle>
            </g>
            <g transform="translate(67 7)">
              <circle r="7" fill="#ffffff" transform="scale(0.01308)">
                <animateTransform
                  attributeName="transform"
                  begin="0s"
                  calcMode="spline"
                  dur="1s"
                  keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                  keyTimes="0;0.5;1"
                  repeatCount="indefinite"
                  type="scale"
                  values="0;1;0"
                />
              </circle>
            </g>
          </svg>
        </Fragment>
      );
    } else if (total) {
      content = `Show  ${total} Results`;
    } else if (total === null) {
      content = 'Show';
    } else {
      content = 'No results';
    }

    return <Button disabled={loading} onClick={handleCloseButtonClick} btnType="primary" type="button">{content}</Button>
  };

  return (
    <Modal>
      <ModalHeader>
        <button type="button" onClick={handleClearButtonClick}>
          Clear
        </button>
        <CloseBtn type="button" onClick={handleCloseButtonClick}>
          <Cross width={16} height={16} />
        </CloseBtn>
      </ModalHeader>
      <ModalContainer>
        <div className="header">
          {title && (
            <ModalTitle>{title}</ModalTitle>
          )}
          {waitlistFeature && (
            <SignUpButton onClick={() => {
              handleModalOpenClick('signUpForEmailAlert');
            }}>
              <Bell />
              Add me to waitlist
            </SignUpButton>
          )}
        </div>
        {children}
      </ModalContainer>
      {displayShowButton && (
        <ModalButtonContainer>
          {renderButtonContent()}
        </ModalButtonContainer>
      )}
    </Modal>
  )
};

SelectorModalMobile.defaultProps = {
  displayShowButton: true,
};

SelectorModalMobile.propTypes = {
  waitlistFeature: PropTypes.bool,
  children: PropTypes.node,
  handleCloseButtonClick: PropTypes.func,
  total: PropTypes.number,
  title: PropTypes.string,
  handleClearButtonClick: PropTypes.func,
  loading: PropTypes.bool,
  displayShowButton: PropTypes.bool,
  handleModalOpenClick: PropTypes.func,
};

const mapDispatchToProps = dispatch => bindActionCreators({
  handleModalOpenClick: openModal,
}, dispatch);


export default connect(null, mapDispatchToProps)(SelectorModalMobile);
